<script setup lang="ts">
import CareerHero from "~/components/careers/CareerHero.vue";
import BenefitsWorkingHere from "~/components/careers/BenefitsWorkingHere.vue";
import CareerList from "~/components/careers/CareerList.vue";

definePageMeta({
    layout: "no-container",
});
</script>

<template>
    <div>
        <CareerHero />

        <BenefitsWorkingHere />

        <CareerList id="career-list" />
    </div>
</template>

<style scoped></style>
